var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
    }
} 

// Read more

$('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.abz-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.abz-description-short'); 
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.abz-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.abz-description-short');
  descriptionShort.style.display = 'block';
});

// cart drawer
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.debouncedUpdate = this.debounce(this.updateItem.bind(this), 300);
  }

  connectedCallback() {
      // Listeners
      document.addEventListener('cart:open', this.open.bind(this));
      document.addEventListener('cart:close', this.close.bind(this));
      document.addEventListener('ajaxProduct:added', this.onItemAdded.bind(this));
      document.addEventListener('cart:updated', (evt) => {
         // If updated from elsewhere (e.g. quantity selector on product page), refresh drawer
         if (evt.target !== document) this.fetchCart();
      });

      const closeBtn = this.querySelector('.cart-drawer__close');
      if(closeBtn) closeBtn.addEventListener('click', this.close.bind(this));
      
      const overlay = this.querySelector('.cart-drawer__overlay');
      if(overlay) overlay.addEventListener('click', this.close.bind(this));

      // Handle clicks (Quantity interactions & Remove)
      this.addEventListener('click', (evt) => {
          // 1. Quantity Plus/Minus
          const qtyBtn = evt.target.closest('.abz-cart-item__qty-btn');
          if (qtyBtn) {
              const input = qtyBtn.parentElement.querySelector('input');
              if (!input) return;

              const key = input.dataset.key;
              let qty = parseInt(input.value);
              
              if (qtyBtn.name === 'plus') {
                  qty += 1;
              } else if (qtyBtn.name === 'minus') {
                  qty -= 1;
                  if (qty < 0) qty = 0;
              }
              this.debouncedUpdate(key, qty);
              return;
          }

          // 2. Remove Button (Trash Icon)
          const removeBtn = evt.target.closest('.abz-cart-item__remove');
          if (removeBtn) {
               const item = removeBtn.closest('.abz-cart-item');
               if (item) {
                   const key = item.dataset.key;
                   this.updateItem(key, 0);
               }
               return;
          }
      });
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  open() {
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
  }

  close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
      document.dispatchEvent(new CustomEvent('headerDrawer:closed'));
  }

  async onItemAdded(evt) {
      this.open();
      if (evt.detail && evt.detail.product && evt.detail.product.sections && evt.detail.product.sections['cart-ajax']) {
          this.render(evt.detail.product.sections['cart-ajax']);
      } else {
          this.fetchCart();
      }
  }

  async fetchCart() {
      try {
        const res = await fetch(`${window.Shopify.routes.root}?section_id=cart-ajax`);
        const text = await res.text();
        this.render(text);
      } catch (e) {
        console.error('Error fetching cart:', e);
      }
  }

  render(htmlStr) {
      const dp = new DOMParser();
      // Handle case where htmlStr is JSON with sections
      let content = htmlStr;
      if (typeof htmlStr === 'object' && htmlStr['cart-ajax']) {
        content = htmlStr['cart-ajax'];
      }
      
      const doc = dp.parseFromString(content, 'text/html');
      
      // Update Body
      const newItems = doc.querySelector('.cart__items');
      const currentItems = this.querySelector('.cart-drawer__body .cart__items');
      
      if (newItems && currentItems) {
          currentItems.replaceWith(newItems);
      } else if (newItems) {
          const body = this.querySelector('.cart-drawer__body');
          if(body) {
              body.innerHTML = '';
              body.appendChild(newItems);
          }
      }
      
      // Update Footer (Discounts)
      const newDiscounts = doc.querySelector('.cart__discounts');
      const currentDiscounts = this.querySelector('.cart__discounts');
      if (newDiscounts) {
           if (currentDiscounts) currentDiscounts.replaceWith(newDiscounts);
           else {
               const footer = this.querySelector('.cart-drawer__footer');
               if(footer) footer.prepend(newDiscounts);
           }
      } else if (currentDiscounts) {
           currentDiscounts.remove();
      }

      // Update Subtotal
      const newSubtotal = doc.querySelector('.cart__subtotal');
      const currentSubtotal = this.querySelector('.cart-drawer__subtotal .cart__subtotal');
      
      if (newSubtotal && currentSubtotal) {
          currentSubtotal.replaceWith(newSubtotal);
      } else if (newSubtotal) {
          // Fallback if current subtotal isn't found but wrapper exists
          const subtotalWrapper = this.querySelector('.cart-drawer__subtotal');
          if (subtotalWrapper) {
              subtotalWrapper.innerHTML = '';
              subtotalWrapper.appendChild(newSubtotal);
          }
      }
      
      // Update Header Count
      const newCountEl = doc.querySelector('[data-count]') || doc.querySelector('.cart__items');
      if (newCountEl) {
          const countVal = newCountEl.getAttribute('data-count');
          const itemsContainer = this.querySelector('.cart__items');
          if(itemsContainer) itemsContainer.setAttribute('data-count', countVal);
          
          // Also update header bubble count if present
          const titleCount = this.querySelector('.cart-drawer__count');
          if (titleCount) titleCount.textContent = `(${countVal})`;

          if (countVal == '0') {
             if(itemsContainer) {
                itemsContainer.innerHTML = `<div class="cart-drawer__empty-message"><p>${this.dataset.emptyMessage}</p></div>`;
             }
          }
      }
  }

  async updateItem(key, qty) {
      const body = JSON.stringify({
          updates: {
              [key]: qty
          },
          sections: ['cart-ajax'] // Reverted to standard section
      });
      
      try {
          const res = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body
          });
          const data = await res.json();
          if(data.sections) {
              this.render(data.sections['cart-ajax']);
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
      } catch(e) {
          console.error(e);
      }

  }
}
customElements.define('cart-drawer', CartDrawer);

// Stock Status
class PdpStockStatus extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.productId = this.dataset.productId;
    this.abortController = new AbortController();

    // The event name is constructed in block.product-variant-picker.js
    // Event format: `variant:change:${sectionId}:${productId}`
    // We need to match how block-variant-picker dispatches it.
    // Based on previous search, it uses util.events.js EVENTS.variantChange which is 'variant:change'
    
    // However, looking at block.product-title.js, it listens to:
    // `${EVENTS.variantChange}:${this.dataset.sectionId}:${this.dataset.productId}`
    // So distinct event name reconstruction: `variant:change:${this.sectionId}:${this.productId}`
    
    document.addEventListener(
      `variant:change:${this.sectionId}:${this.productId}`,
      this.handleVariantChange.bind(this),
      { signal: this.abortController.signal }
    );
  }

  disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
  }

  handleVariantChange(event) {
    const { html, variant } = event.detail;
    
    if (!variant || !variant.available) {
        this.updateStatus(false);
    } else {
        this.updateStatus(true);
    }
  }

  updateStatus(isAvailable) {
      this.classList.remove('in-stock', 'out-of-stock');
      if (isAvailable) {
          this.classList.add('in-stock');
          this.textContent = 'In stock';
      } else {
          this.classList.add('out-of-stock');
          this.textContent = 'Out of stock';
      }
  }
}

customElements.define('pdp-stock-status', PdpStockStatus);

// tabs collections
$(document).ready(function(){

  $('#horizontal').owlCarousel({
    margin: 10,
    nav: true,
    dots: false,
    autoWidth: true,
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    freeDrag: false,

    navText: [
      '<i class="Abz-Next"></i>',
      '<i class="Abz-Prev"></i>'
    ],

    responsive:{
      0:{ items:2 },
      600:{ items:3 },
      1000:{ items:5 }
    }
  });

});


// remove lazy
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
    img.setAttribute("loading", "eager");
  });
});

